<app-header [forceLightBackground]="true"></app-header>
<div class="provider-support">
  <div class="flex min-h-screen w-full flex-col lg:flex-row">
    <div class="provider-support--sidebar-col">
      <app-provider-sidebar></app-provider-sidebar>
    </div>
    <div class="provider-support--content flex-1 min-w-0">
      <app-page-header></app-page-header>
      <div class="support--container">
        <app-support></app-support>
      </div>
    </div>
  </div>
</div>
